import { useContext, useEffect } from 'react'
import { AppContext } from '../AppContext'

export function useSuppressCutterHotkeys() {
  const { setHotkeysEnabled } = useContext(AppContext)

  useEffect(() => {
    setHotkeysEnabled(false)

    return () => setHotkeysEnabled(true)
  }, [setHotkeysEnabled])
}
